module.exports = __webpack_public_path__ + "assets/img/thumb-The-Dream-Collective-Website.d9f3bbcd.webp";